import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <div className="privacy-container">
        <h2>Welcome to HYNT's privacy policy ("<strong>Privacy Policy</strong>" or "<strong>Policy</strong>")</h2>
        <p className="last-updated">Last updated: 15th March, 2026</p>

        <p>
          <strong>HYNT SOLUTIONS PRIVATE LIMITED</strong> (formerly known as <strong>HYNT Solutions LLP</strong>, previously{' '}
          <strong>CircleSpace LLP</strong>) and its affiliates a company incorporated under the Companies Act, 2013,
          having its registered office at 1201 A Wing New Light CHS, TPS IV South Avenue Khar, Khar Colony,
          Mumbai, Mumbai- 400052, Maharashtra and Corporate Identification Number (CIN):{' '}
          <strong>U58200MH2026PTC465233</strong> (collectively, <strong>"HYNT"</strong>, <strong>"we"</strong>,{' '}
          <strong>"us"</strong> or <strong>"our"</strong>) is engaged in the business of providing web-based solutions
          to facilitate connections between customers that seek specific services including but not limited to
          Architecture, Interior Designs, CCTV &amp; Security Systems, Home Appliances and Furniture, electrical
          appliances, photographers, publishers, and more, and service professionals that offer these services. In
          essence, we offer an integrated, one-stop solution to transform a mere house into a warm and personalized
          home. This Policy outlines our practices in relation to the collection, storage, usage, processing, and
          disclosure of data/information including personal data/information that you have shared or consented to
          share with us when you access, use, or otherwise interact with our website available at{' '}
          <a href="https://hynt.co.in/">hynt.co.in</a> or mobile application 'HYNT' (collectively,{' '}
          <strong>"Platform"</strong>) or avail products or services offered on or through the Platform
          (collectively, the <strong>"Services"</strong>). In this Policy, the services offered to you by service
          professionals on or through the Platform are referred to as <strong>"Professional Services"</strong>.
        </p>

        <p>
          At HYNT, we are committed to protecting your personal data and respecting your privacy. In order to
          provide you with access to the Services or the Professional Services, we have to collect and otherwise
          process certain data about you. This Policy explains how we process and use personal data about you.
        </p>

        <p>
          Please note that unless specifically defined in this Policy, capitalised terms shall have the same meaning
          ascribed to them in our Terms and Conditions, available at{' '}
          <a href="https://hynt.co.in/terms">hynt.co.in/terms</a> ("<strong>Terms</strong>"). Please read this
          Policy in consonance with the Terms.
        </p>

        <p>
          By using the Services, you confirm that you have read and agree to be bound by this Policy and consent to
          the processing activities described under this Policy.
        </p>

        <p>Please refer to Paragraph 1 to understand how the terms of this Policy apply to you.</p>

        <ul className="root">

          {/* 1. BACKGROUND AND KEY INFORMATION */}
          <li>
            <strong>BACKGROUND AND KEY INFORMATION:</strong>
            <ul className="alpha">
              <li>
                <strong>How this Policy applies:</strong><br />
                This Policy including our Cookie Policy applies to individuals who access or use the Services or
                otherwise avail the Professional Services. For the avoidance of doubt, references to{' '}
                <strong>"you"</strong> across this Policy are to an end user that uses the Platform. By using the
                Platform, you consent to the collection, storage, usage, and disclosure of your personal data, as
                described in and collected by us in accordance with this Policy.
              </li>
              <li>
                <strong>Review and Updates:</strong><br />
                We regularly review and update our Privacy Policy, and we request you to regularly review this
                Policy. It is important that the personal data we hold about you is accurate and current. Please
                let us know if your personal data changes during your relationship with us.
              </li>
              <li>
                <strong>Changes to the Policy:</strong><br />
                Changes to the Privacy Policy apply to your use of our Services. HYNT can modify this Privacy
                Policy, and if we make material changes to it, we will provide notice through our Services, or by
                other means, to provide you the opportunity to review the changes before they become effective. If
                you object to any changes, your account may be limited or restricted. You acknowledge that your
                continued use of our Services after we publish or send a notice about our changes to this Privacy
                Policy means that the collection, use and sharing of your personal data is subject to the updated
                Privacy Policy, as of its effective date.
              </li>
              <li>
                <strong>Third-Party Services:</strong><br />
                The Platform may include links to third-party websites, plug-ins, services, and applications
                (<strong>"Third-Party Services"</strong>). Clicking on those links or enabling those connections
                may allow third parties to collect or share data about you. We neither control nor endorse these
                Third-Party Services and are not responsible for their privacy statements. When you leave the
                Platform or access third-party links through the Platform, we encourage you to read the privacy
                policy of such third-party service providers.
              </li>
            </ul>
          </li>

          {/* 2. PERSONAL DATA THAT WE COLLECT */}
          <li>
            <strong>PERSONAL DATA THAT WE COLLECT:</strong>
            <ul className="alpha">
              <li>
                We collect only such personal data as is necessary for the purposes described in this Policy and
                limit collection to what is relevant and reasonably required for providing the Services. This
                includes, but is not limited to:
                <ul className="roman">
                  <li>
                    <strong>Contact Data,</strong> such as your mailing or home address, email addresses, and
                    mobile numbers.
                  </li>
                  <li>
                    <strong>Identity and Profile Data,</strong> such as your name, username or similar
                    identifiers, photographs, Aadhaar Number, PAN number, gender and other information you may
                    choose to provide us where permitted under applicable law and strictly for lawful purposes.
                    If you are a professional, you may also provide us with information related to your
                    business, including a business name, description, phone number, and areas served. If you
                    use financial tools or services offered through our Platform, for example, to request or
                    accept payments for your business services, or to register for a Premium Service, we
                    collect information to facilitate those transactions, such as proof of business ownership,
                    bank name, account numbers, tax numbers, credit card and other documentation as needed to
                    verify your identity or integrate with our service providers.
                  </li>
                  <li>
                    <strong>Marketing and Communications Data,</strong> such as your address, email address,
                    information posted in service requests, offers, wants, feedback, comments, pictures and
                    discussions in our blog and chat boxes, responses to user surveys and polls, your
                    preferences in receiving marketing communications from us and our third parties, and your
                    communication preferences. We also collect your chat and call records when you communicate
                    with service professionals through the Platform. We employ such systems to proactively
                    manage or restrict content, either suo motu or upon receiving a report from you, that is
                    found to be in violation of applicable professional community guidelines or any law
                    currently in force in India.
                  </li>
                  <li>
                    <strong>Posting and Uploading.</strong> We collect personal data from you when you
                    provide, post or upload it to our Services, such as when you fill out a form (e.g., with
                    project costs, BOQs, expenses), respond to a survey, or submit a resume or fill out a job
                    application on our Services or store invoices, drawings, contracts and references. If you
                    sync your calendars with our Services, we will collect your calendar meeting information to
                    keep growing your network by suggesting connections for you and others, and by providing
                    information about events, e.g. times, places, attendees and contacts. You don't have to
                    post or upload personal data; though if you don't, it may limit your ability to grow and
                    engage with your network over our Services.
                  </li>
                  <li>
                    <strong>Technical Data,</strong> which includes your IP address, browser type and add-ons,
                    internet service provider, details of operating system, access time, page views, device ID,
                    device type, proxy server, device identifier and features, cookie IDs and/or ISP, or your
                    mobile carrier, frequency of visiting our website and use of the Platform, website and
                    mobile application activity, clicks, date and time stamps, location data, and other
                    technology on the devices that you use to access the Platform. We will ask you to opt-in
                    before we use GPS or other tools to identify your precise location. If you use our Services
                    from a mobile device, that device will send us data about your location based on your phone
                    settings. This will enable end users to conduct more accurate and refined location-based
                    searches. When you visit or leave our Services (including some plugins and our cookies or
                    similar technology on the sites of others), we receive the URL of both the site you came
                    from and the one you go to and the time of your visit.
                  </li>
                  <li>
                    <strong>Transaction Data,</strong> such as details of the Services or Professional
                    Services you have availed, a limited portion of your credit or debit card details for
                    tracking transactions that are provided to us by payment processors, UPI IDs for processing
                    payments and other billing information. We do not store full card numbers and rely on
                    RBI-compliant payment processors.
                  </li>
                  <li>
                    <strong>Usage Data,</strong> which includes information about how you use the Services and
                    Professional Services, your activity on the Platform,
                    booking/appointment/consultancy history, user taps and clicks, user interests, time spent
                    on the Platform, details about user journey on the mobile application, page views, search
                    history, installation or updating of our mobile apps, sharing drawings, completed projects,
                    or applying for jobs. We use log-ins, cookies, device information and internet protocol
                    ("IP") addresses to identify you and log your use.
                  </li>
                </ul>
              </li>
              <li>
                We also collect, use, and share aggregated data such as statistical or demographic data for any
                purpose. Aggregated data could be derived from your personal data but is not considered personal
                data under law as it does not directly or indirectly reveal your identity. However, if we combine
                or connect aggregated data with your personal data so that it can directly or indirectly identify
                you, we treat the combined data as personal data which will be used in accordance with this
                Policy.
              </li>
              <li>
                <strong>What happens if you refuse to provide your personal data?</strong><br />
                Where we need to collect personal data by law, or under the terms of a contract (such as the
                Terms), and you fail to provide that data when requested, we may not be able to perform the
                contract (for example, to provide you with the Services). In this case, we may have to cancel or
                limit your access to the Services.
              </li>
            </ul>
          </li>

          {/* 3. HOW DO WE COLLECT PERSONAL DATA */}
          <li>
            <strong>HOW DO WE COLLECT PERSONAL DATA?</strong>
            <p>We use different methods to collect personal data from and about you including through:</p>
            <ul className="alpha">
              <li>
                <strong>Direct Interactions.</strong> You provide us your personal data when you interact with
                us. This includes personal data you provide when you:
                <ul className="roman">
                  <li>create an account or profile with us or updating the same;</li>
                  <li>use our Services or carry out other activities in connection with the Services;</li>
                  <li>enter a promotion, user poll, or online surveys;</li>
                  <li>
                    request marketing communications, newsletters, updates, or other information to be sent to
                    you via email, messages or other communication channels; or
                  </li>
                  <li>
                    report a problem with the Platform and/or our Services, request assistance, give us
                    feedback, suggestions or otherwise contact us.
                  </li>
                </ul>
              </li>
              <li>
                <strong>Automated technologies or interactions</strong> — each time you visit the Platform or
                use the Services, we will automatically collect Technical Data about your equipment, browsing
                actions, and patterns. We collect this personal data by using cookies, web beacons, pixel tags,
                server logs, and other similar technologies. We may also receive Technical Data about you if you
                visit other websites or apps that employ our cookies. You can opt out from our use of data from
                cookies and similar technologies that track your behaviour on the sites of others for ad
                targeting and other ad-related purposes.
              </li>
              <li>
                <strong>Third parties or publicly available sources</strong> — We may receive information about
                you from third-party platforms when you allow the third-party platform to share this information
                with us or allow HYNT to obtain this information from the third party. For example, we may
                receive information such as your name, email address, and profile photo when you sign up for our
                Platform through Facebook, Google, or Apple. We may also receive information about you when you
                upload your contacts from your third-party email service, use our Platform (or a third-party
                integration on our Platform) to manage your calendar on another platform, or to manage and send
                communications (e.g., email or text messages). We will receive the following personal data about
                you from various third parties:
                <ul className="roman">
                  <li>Technical data from analytics providers such as Facebook and advertising networks;</li>
                  <li>
                    Identity and profile-related Data and Contact Data from service professionals, publicly
                    available sources, etc.;
                  </li>
                  <li>
                    Personal data about you from our affiliate entities, industry associations, dealer networks
                    in which you participate and display your affiliation with these organizations;
                  </li>
                  <li>Details of any license you have using publicly available records;</li>
                  <li>
                    Information about you from our partners and service providers. For example, our payment
                    processors may update your payment information, advertising partners may help us send you
                    communications, and third parties may help us prevent fraud by verifying your contact
                    information.
                  </li>
                </ul>
              </li>
            </ul>
          </li>

          {/* 4. HOW DO WE USE YOUR PERSONAL DATA */}
          <li>
            <strong>HOW DO WE USE YOUR PERSONAL DATA?</strong>
            <ul className="alpha">
              <li>
                <strong>We will only use your personal data when the law allows us to,</strong> including where
                you have provided consent, where processing is necessary for the performance of a contract with
                you, where such processing is required under applicable law, or for legitimate business purposes
                permitted under applicable law. Most commonly, we will use your personal data where we need to
                provide you with the Services, enable you to use the Professional Services, or where we need to
                comply with a legal obligation. We use your personal data for the following purposes:
                <ul className="roman">
                  <li>
                    to verify your identity to register you as a user, and create your user account with us on
                    the Platform;
                  </li>
                  <li>to provide the Services to you;</li>
                  <li>to enable the provision of Professional Services to you;</li>
                  <li>
                    to monitor trends and personalise your experience such as tailoring the content and
                    information made available to you;
                  </li>
                  <li>
                    to improve the functionality of our Services based on the information and feedback we
                    receive from you;
                  </li>
                  <li>
                    to improve customer service to effectively respond to your Service requests and support
                    needs;
                  </li>
                  <li>to track transactions and process payments;</li>
                  <li>
                    to send periodic notifications to manage our relationship with you including to notify you
                    of changes to the Services, send you information and updates pertaining to the Services you
                    have availed, and to receive occasional news and updates related to us or the Services;
                  </li>
                  <li>
                    to assist with the facilitation of the Professional Services offered to you, including to
                    send you information and updates about the Professional Services you have availed;
                  </li>
                  <li>
                    to display relevant or targeted advertising (on our Platform and third-party sites) for us
                    and other businesses and to evaluate the success of such advertising;
                  </li>
                  <li>to comply with legal obligations;</li>
                  <li>
                    to prevent fraud and to maintain a quality experience for our business purposes or legal
                    reasons, including to filter for spam and communications that violate our agreements with
                    you;
                  </li>
                  <li>
                    to administer and protect our business and the Services, including for troubleshooting,
                    data analysis, system testing, and performing internal operations;
                  </li>
                  <li>to improve our business and delivery models;</li>
                  <li>
                    to perform our obligations that arise out of the arrangement we are about to enter or have
                    entered with you;
                  </li>
                  <li>
                    to perform research and analysis for our business purposes and to conduct journalist
                    research;
                  </li>
                  <li>to enforce our Terms; and</li>
                  <li>
                    to respond to court orders, establish or exercise our legal rights, or defend ourselves
                    against legal claims.
                  </li>
                </ul>
              </li>
              <li>
                <strong>
                  You agree and acknowledge that by using our Services and creating an account with us on the
                  Platform,
                </strong>{' '}
                you authorise us, our service professionals, associate partners, and affiliates to contact you
                via email, phone, or otherwise. This is to provide the Services to you and ensure that you are
                aware of all the features of the Services and for related purposes.
              </li>
              <li>
                <strong>
                  You agree and acknowledge that any and all information pertaining to you,
                </strong>{' '}
                whether or not you directly provide it to us (via the Services or otherwise), including but not
                limited to personal correspondence such as emails, instructions from you, etc., may be collected,
                compiled, and shared by us in order to render the Services to you. This may include but not be
                limited to service professionals who provide or seek to provide you with Professional Services,
                vendors, social media companies, third-party service providers, data analytics providers,
                consultants, architects, lawyers, and auditors. We may also share this information with other
                entities in the HYNT group, subsidiaries, affiliates, or associated companies, in connection with
                the above-mentioned purposes.
              </li>
              <li>
                <strong>You agree and acknowledge that we may share data without your consent,</strong> when it
                is required by law or by any court or government agency or authority to disclose such
                information. Such disclosures are made in good faith and belief that it is reasonably necessary
                to do so for enforcing this Policy or the Terms, or in order to comply with any applicable laws
                and regulations.
              </li>
            </ul>
          </li>

          {/* 5. COOKIES AND OTHER TRACKING TECHNOLOGIES */}
          <li>
            <strong>COOKIES AND OTHER TRACKING TECHNOLOGIES:</strong>
            <ul className="alpha">
              <li>
                <strong>Cookies are small files</strong> that a site or its service provider transfers to your
                device's hard drive through your web browser (if you permit it to) that enables the sites or
                service providers' systems to recognise your browser and capture and remember certain
                information. We use both Session and Persistent Cookies for the purposes set out below:
                <ul className="roman">
                  <li>
                    <strong>Necessary / Essential Cookies</strong><br />
                    Type: Session Cookies<br />
                    Administered by: Us<br />
                    Purpose: These Cookies are essential to provide you with services available through the
                    Platform and to enable you to use some of its features. They help to authenticate users and
                    prevent fraudulent use of user accounts. Without these Cookies, the services that you have
                    asked for cannot be provided, and we only use these Cookies to provide you with those
                    services.
                  </li>
                  <li>
                    <strong>Cookies Policy / Notice Acceptance Cookies</strong><br />
                    Type: Persistent Cookies<br />
                    Administered by: Us<br />
                    Purpose: These Cookies identify if users have accepted the use of cookies on the Website.
                  </li>
                  <li>
                    <strong>Functionality Cookies</strong><br />
                    Type: Persistent Cookies<br />
                    Administered by: Us<br />
                    Purpose: These Cookies allow us to remember choices you make when you use our Platform. The
                    purpose of these Cookies is to provide you with a more personal experience.
                  </li>
                  <li>
                    <strong>Tracking and Performance Cookies</strong><br />
                    Type: Persistent Cookies<br />
                    Administered by: Third-Parties<br />
                    Purpose: These Cookies are used to track information about traffic to the Platform and how
                    users use the Platform. The information gathered via these Cookies may directly or
                    indirectly identify you as an individual visitor. This is because the information collected
                    is typically linked to a pseudonymous identifier associated with the device you use to
                    access the Website. We may also use these Cookies to test new pages, features or new
                    functionality of the Website to see how our users react to them.
                  </li>
                </ul>
              </li>
              <li>
                <strong>We use cookies</strong> to help us distinguish you from other users of the Platform,
                understand and save your preferences for future visits, keep track of advertisements and compile
                aggregate data about site traffic and site interaction so that we can offer you a seamless user
                experience. We may contact third-party service providers to assist us in better understanding our
                site visitors. These service providers are not permitted to use the information collected on our
                behalf except to help us conduct and improve our business.
              </li>
              <li>
                <strong>Additionally, you may encounter cookies</strong> or other similar devices on certain
                pages of the Platform that are placed by third parties. We do not control the use of cookies by
                third parties. If you send us personal correspondence, such as emails, or if other users or third
                parties send us correspondence about your activities or postings on the Platform, we may collect
                such information within a file specific to you.
              </li>
            </ul>
          </li>

          {/* 6. DISCLOSURES OF YOUR PERSONAL DATA */}
          <li>
            <strong>DISCLOSURES OF YOUR PERSONAL DATA</strong>
            <ul className="alpha">
              <li>
                <strong>We may share your personal data with third parties</strong> set out below for the
                purposes set out in Paragraph 4:
                <ul className="roman">
                  <li>
                    Service professionals to enable them to provide you with Professional Services. Through our
                    Platform, others have the ability to find, contact, view, and follow your profile and public
                    activity on HYNT. You can customize your HYNT profile and whether users may follow you
                    through your HYNT Settings. Your HYNT content (for example, photos, notes on others'
                    photos, projects, discussions, and social media profiles), followers, and others you follow
                    are publicly viewable on the Platform and open to comments by other users. If you are a
                    professional, we may also display information to help visitors and users evaluate you;
                  </li>
                  <li>
                    Internal third parties, which are other companies subsidiaries, affiliates, or joint
                    ventures within the HYNT groups;
                  </li>
                  <li>
                    External third parties such as:
                    <ul>
                      <li>
                        trusted third parties such as our associate partners, and service providers that
                        provide services for us or on our behalf. This includes hosting and operating our
                        Platform, providing marketing assistance, conducting our business, processing payments
                        and transaction-related processes, transmitting content, and providing our Services to
                        you;
                      </li>
                      <li>
                        analytic service providers and advertising networks that conduct web analytics for us
                        to help us improve the Platform and to assist us in evaluating the effectiveness of our
                        advertising. These analytics providers may use cookies and other technologies to
                        perform their services;
                      </li>
                      <li>
                        our Platform may include third-party social media features and other third-party
                        plug-ins and widgets. When these features are displayed on our Platform, they are
                        operated or hosted by third parties;
                      </li>
                      <li>
                        other registered users on our Platform upon your request or where you explicitly
                        consent to such disclosure; and
                      </li>
                      <li>regulators and other bodies, as required by law or regulation.</li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <strong>We require all third parties</strong> to respect the security of your personal data and
                to treat it in accordance with the law. We do not allow our third-party service providers to use
                your personal data for their own purposes and only permit them to process your personal data for
                specified purposes and in accordance with our instructions.
              </li>
            </ul>
          </li>

          {/* 7. YOUR CHOICES AND RIGHTS */}
          <li>
            <strong>YOUR CHOICES AND RIGHTS IN RELATION TO YOUR PERSONAL DATA</strong>
            <ul className="alpha">
              <li>
                <strong>Access and Updating your Personal Data:</strong> You hereby warrant that all personal
                data that you provide us with is accurate, up-to-date, and true. When you use our Services, we
                make best efforts to provide you with the ability to access and correct inaccurate or deficient
                data, subject to applicable law, you may have the right to access, correct, update, or request
                deletion of your personal data, or withdraw consent for its processing. You can request HYNT
                SOLUTIONS PRIVATE LIMITED for a copy of your personal data by sending an email to{' '}
                <a href="mailto:grievances@hynt.co.in">grievances@hynt.co.in</a>. HYNT SOLUTIONS PRIVATE
                LIMITED may respond to such request within the timelines prescribed under applicable law.
              </li>
              <li>
                <strong>Opting-out of Marketing and Promotional Communications:</strong> When we send you
                marketing and promotional content through email, we make best efforts to provide you with the
                ability to opt-out of such communications by using the opt-out instructions provided in such
                emails. You understand and acknowledge that it may take us up to 10 (Ten) business days to give
                effect to your opt-out request. Please note that we may still send you emails about your user
                account or any Services you have requested or received from us.
              </li>
              <li>
                <strong>Cookie Preferences:</strong> You may opt-out of certain cookies set via the Platform by
                visiting your HYNT settings or through your browser settings.
              </li>
            </ul>
          </li>

          {/* 8. DELETION OF ACCOUNT AND PERSONAL DATA */}
          <li>
            <strong>DELETION OF ACCOUNT AND PERSONAL DATA</strong>
            <ul className="alpha">
              <li>
                <strong>Account Deletion:</strong> Notwithstanding anything contained in the Terms, you may
                delete your account as well as your personal data stored with HYNT SOLUTIONS PRIVATE LIMITED by
                sending an email to{' '}
                <a href="mailto:grievances@hynt.co.in">grievances@hynt.co.in</a>. HYNT SOLUTIONS PRIVATE
                LIMITED may process your request within the timelines prescribed under applicable law. Once your
                account is deleted, you will lose access to all Services. For avoidance of doubt, it is hereby
                clarified that all data with respect to transactions performed by you on the Platform will be
                retained in accordance with applicable law.
              </li>
            </ul>
          </li>

          {/* 9. TRANSFERS OF YOUR PERSONAL DATA */}
          <li>
            <strong>TRANSFERS OF YOUR PERSONAL DATA</strong>
            <ul className="alpha">
              <li>
                <strong>Compliance with Laws:</strong> We comply with applicable laws in respect of storage,
                processing and transfers of personal data. As a part of your use of the Services, the information
                and personal data you provide to us may be transferred to and stored in countries other than the
                country you are based in. This may happen if any of our servers are from time to time located in
                a country other than the one you are based, or one of our vendors, partners, or service providers
                is located in a country other than one you are based in. When we transfer your information to
                countries that may not have equivalent privacy and data protection rules to the laws of your
                country, we take measures to comply with the applicable data protection laws related to our
                transfer.
              </li>
              <li>
                <strong>Consent to Cross-Border Transfer:</strong> By submitting your information and personal
                data to us, you agree to such cross-border transfer, storage, and processing of such information
                and personal data in the manner described above including where such transfers are made only to
                jurisdictions approved by the Government of India, if so required under applicable law. We shall
                ensure that any such transfers are subject to appropriate contractual, technical, or
                organizational safeguards, so as to provide a level of data protection that is consistent with
                the standards required under applicable law.
              </li>
            </ul>
          </li>

          {/* 10. DATA SECURITY */}
          <li>
            <strong>DATA SECURITY</strong>
            <ul className="alpha">
              <li>
                <strong>Security Measures:</strong> We implement appropriate and reasonable security measures
                and privacy-protective features on our Platform including encryption, password protection, call
                masking, firewalls, authentications and physical security measures to protect your personal data
                from unauthorised access and disclosure, and follow standards prescribed by applicable law. We
                regularly monitor our systems for possible vulnerabilities and attacks. However, we cannot warrant
                the security of any information that you send us. There is no guarantee that data may not be
                accessed, disclosed, altered, or destroyed by breach of any of our physical, technical, or
                managerial safeguards.
              </li>
              <li>
                <strong>Password Responsibility:</strong> Where you have chosen a password that enables you to
                access certain parts of the Services or Professional Services, you are responsible for keeping
                this password secret and confidential. We will not be responsible for any unauthorised use of
                your information, or for any lost, stolen, or compromised passwords, or for any activity on your
                user account due to such unauthorised disclosure of your password. In the event your password has
                been compromised in any manner whatsoever, you should promptly notify us to enable us to initiate
                a change of password.
              </li>
            </ul>
          </li>

          {/* 11. DATA RETENTION */}
          <li>
            <strong>DATA RETENTION</strong>
            <ul className="alpha">
              <li>
                <strong>Retention Period:</strong> You agree and acknowledge that your personal data will
                continue to be stored and retained by us for as long as necessary to fulfil the purposes set out
                in this Policy, and thereafter only for such period as required under applicable law, for
                enforcement of our legal rights, prevention of fraud, or for legitimate business purposes on the
                Platform or access to the Services to comply with our legal rights and obligations.
              </li>
              <li>
                <strong>Information Shared with Others:</strong> Personal information you have shared with
                others may remain visible after your account has been deactivated, deleted or after the
                information has been removed from your own profile or account. Please note that copies of
                information that you have updated, modified, or deleted may continue to reside in our systems for
                a period of time, and we may maintain copies of this information as part of our business records.
              </li>
              <li>
                <strong>Aggregated Data:</strong> In some circumstances, we may aggregate your personal data (so
                that it can no longer be associated with you) for research or statistical purposes, in which case
                we may use this information indefinitely without further notice to you.
              </li>
            </ul>
          </li>

          {/* 12. BUSINESS TRANSITIONS */}
          <li>
            <strong>BUSINESS TRANSITIONS</strong><br />
            You are aware that in the event we go through a business transition, such as a merger, acquisition
            by another organisation, or sale of all or a portion of our assets, or corporate restructuring or
            conversion, your personal data might be among the assets transferred.
          </li>

          {/* 13. USER GENERATED CONTENT */}
          <li>
            <strong>USER GENERATED CONTENT</strong><br />
            We invite you to post content on our Platform, including your comments, feedback, pictures, or any
            other information that you would like to be made available on our Platform. Please note that such
            content will be available to all visitors to our Platform and may become public. We cannot prevent
            such information from being used in a manner that is contrary to this Policy, applicable laws, or
            your personal privacy, and we disclaim all liability (express or implied) in this regard. Further,
            you agree to comply with all applicable laws in relation to the content uploaded or otherwise shared
            by you on our Platform. You understand and acknowledge that you will be solely responsible for any
            information published by you on our Platform that violates applicable laws in force in India.
          </li>

          {/* 14. GRIEVANCE OFFICER */}
          <li>
            <strong>GRIEVANCE OFFICER</strong><br />
            If you have any questions or concerns about this Policy, how we process or handle your personal
            data, or otherwise, you may reach out to us with your queries, grievances, feedback, and comments
            at <a href="mailto:grievances@hynt.co.in">grievances@hynt.co.in</a> or contact our grievance
            officer whose contact details are provided below:
            <ul>
              <li><strong>Name:</strong> Harsh Shah</li>
              <li><strong>Designation:</strong> COO</li>
              <li>
                <strong>Email:</strong>{' '}
                <a href="mailto:grievances@hynt.co.in">grievances@hynt.co.in</a>
              </li>
            </ul>
            The Grievance Officers will investigate the complaint and determine whether a breach has occurred
            and what action, if any, to take. We will take any privacy complaint seriously and will aim to
            resolve any such complaint in a timely and efficient manner. We expect our procedures will deal
            fairly and promptly with your complaint.
          </li>

        </ul>
      </div>
    </div>
  );
}

export default PrivacyPolicy;